import React from 'react';
import { Theme as AugmentedTheme, useMediaQuery, useTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

import { useTranslation } from 'react-i18next';
import { Box, Divider, Grid, KeyValue } from 'web-library';
import CustomFeeRow from './CustomFeeRow';
import { ExamGroupExamLevelFeeResponse, ExamPayment } from '../api-refactored/typings';

const useStyles = makeStyles()((theme) =>
({
  value: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  dividerContainer: {
    '& .MuiBox-root': {
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
    },
  },
}));

interface IExamFeeDetails {
  gstRegistrationNumber?: string;
  groupedLevelFees?: ExamGroupExamLevelFeeResponse[];
  payment?: ExamPayment;
  className?: any;
}

const showGstIndicator = (isIPsle?: number, gstIndicator?: string) => !isIPsle || gstIndicator;

const ExamFeeDetails = (props: IExamFeeDetails) => {
  const { t } = useTranslation();
  const { gstRegistrationNumber, groupedLevelFees, payment, className } = props;

  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isIPsle =
    groupedLevelFees?.length &&
    groupedLevelFees.filter((item) => item.examLevel === 'iPSLE').length;
  const gstPercentage = isIPsle && !payment?.gstIndicator ? null : payment?.gstPercentage || '7';

  return (
    <Box className={className}>
      {gstRegistrationNumber && (
        <KeyValue
          id="gstRegistrationNumber"
          keyText={t('components->>SelectedSubjectReview.GST Reg No.')}
          valueText={gstRegistrationNumber}
        />
      )}
      {groupedLevelFees &&
        groupedLevelFees.map((item, index) => (
          <Box key={`groupedLevelFees-${item.examLevel}`}>
            <CustomFeeRow
              label={item.examLevel}
              value={t('components->>SelectedSubjectReview.Amount (SGD)')}
              currencyDenomination={false}
              variant="header"
            />
            {item.adminFee && (
              <CustomFeeRow label={t('exam->>ReviewExam.Admin Fee')} value={item.adminFee} />
            )}
            {item.basicFee && (
              <CustomFeeRow label={t('exam->>ReviewExam.BasicFee')} value={item.basicFee} />
            )}
            {item.lateEntryFee && (
              <CustomFeeRow
                label={t('exam->>ReviewExam.Late Entry Fee')}
                value={item.lateEntryFee}
              />
            )}
            {item.amendmentFee && (
              <CustomFeeRow
                label={t('exam->>ReviewExam.Amendment Fee')}
                value={item.amendmentFee}
              />
            )}
            {item.subjectAdminFee && (
              <CustomFeeRow
                label={t('exam->>Review.Subject Admin Fee')}
                value={item.subjectAdminFee}
              />
            )}
            {item.totalSubjectFee && (
              <CustomFeeRow
                label={t('exam->>ReviewExam.Total Subject Fee')}
                value={item.totalSubjectFee}
              />
            )}
            {item.subtotal && (
              <CustomFeeRow
                variant="subFooter"
                label={t('exam->>ReviewExam.Subtotal')}
                value={item.subtotal}
              />
            )}
          </Box>
        ))}
      <Grid className={classes.dividerContainer} xs={12} sm={6}>
        <Divider />
      </Grid>
      <CustomFeeRow
        label={t('exam->>ReviewExam.TotalExamFees')}
        value={!isMobile ? t('components->>SelectedSubjectReview.Amount (SGD)') : ''}
        currencyDenomination={false}
        variant="header"
      />
      {payment && (
        <>
          {gstPercentage && (
            <CustomFeeRow
              label={t('exam->>ReviewExam.Goods and Services Tax (GST)', {
                gstPercentage,
              })}
              value={payment.totalGst}
            />
          )}
          {payment.totalWithdrawalAmount && (
            <CustomFeeRow
              label={t('components->>SelectedSubjectReview.Total Withdrawal Amount')}
              value={payment.totalWithdrawalAmount}
            />
          )}
          {showGstIndicator(isIPsle, payment.gstIndicator) && (
            <CustomFeeRow
              label={t('components->>SelectedSubjectReview.TotalPayableFeeInclGST')}
              value={payment.totalFee}
            />
          )}
          <CustomFeeRow
            label={t('components->>SelectedSubjectReview.TotalPayable')}
            value={payment.totalPayable || '0.00'}
            variant="footer"
          />
        </>
      )}
    </Box>
  );
};
export default ExamFeeDetails;
